import { RouteObject } from "react-router-dom";
import BulkBillCreate from "./components/Create/Create";
import { BulkBillingDetail } from "./components/Detail/Detail";
import { BulkBillingLanding } from "./components/List/Landing";
export interface BulkBillGenerationRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BulkBillGenerationRoute[];
}
export const bulkBillRoutes: BulkBillGenerationRoute[] = [
  {
    path: "bx/create-bill-generation",
    element: <BulkBillingLanding />,
  },
  {
    path: "/bx/bulk-billing/detail/:id",
    element: <BulkBillingDetail />,
  },
  {
    path: "/bx/bulk-billing/create",
    element: <BulkBillCreate />,
  },
  {
    path: "/bx/bulk-billing/create/:id/:action",
    element: <BulkBillCreate />,
  },
  {
    path: "/bx/bulk-billing/create/:id/:cycleId/:action",
    element: <BulkBillCreate />,
  },
  {
    path: "/bx/bulk-billing/create/:id/:cycleId/:runId/:action",
    element: <BulkBillCreate />,
  },
];
